import { Button, Checkbox, Flex, Form, Space, Typography } from 'antd';

import { CustomAlert } from '@app/components';
import { ERROR, PREFIX } from '@app/constants';
import type { NEmployees } from '@app/types/Employees';

import { useEmployeeSettingsTab } from '@pages/Employees/EditEmployee/components/EmployeeSettingsTab/hooks/useEmployeeSettingsTab';

import '@pages/Employees/EditEmployee/components/EmployeeSettingsTab/styles/EmployeeSettingsTab.desktop.scss';
import '@pages/Employees/EditEmployee/components/EmployeeSettingsTab/styles/EmployeeSettingsTab.tablet.scss';

const { Text } = Typography;

export const EmployeeSettingsTab = (data: NEmployees.EmployeeSettingsTab) => {
  const {
    employee,
    allSettings,
    hasCurrentUserRightToViewAllRecords = false,
  } = data;
  const { form, submitForm, isLoading, error, setError } =
    useEmployeeSettingsTab(employee, allSettings);

  return (
    <div className={`${PREFIX}settings-info`}>
      <Form
        style={{ maxWidth: '800px', width: '100%' }}
        onFinish={(values) => submitForm(values)}
        form={form}
      >
        <Space direction="vertical" size="large" className="form-space">
          <div className="container">
            <Flex>
              <Text className="label" strong data-testid="notification">
                Уведомления
              </Text>

              <div>
                {employee?.isEmployee && (
                  <>
                    <Form.Item
                      name="IsSkipRecordNotifications"
                      valuePropName="checked"
                      className="checkbox-field"
                    >
                      <Checkbox data-testid="notification-checkbox">
                        <Text data-testid="notification-text">
                          Отправка клиенту уведомлений по предстоящим записям
                        </Text>
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      name="IsRecordStatusChanges"
                      valuePropName="checked"
                      className="checkbox-field"
                    >
                      <Checkbox>
                        Отправка исполнителю в WhatsApp уведомлений о смене
                        статуса записи
                      </Checkbox>
                    </Form.Item>
                  </>
                )}
                {hasCurrentUserRightToViewAllRecords && (
                  <Form.Item
                    name="IsAllRecordsStatusChanges"
                    valuePropName="checked"
                    className="checkbox-field"
                  >
                    <Checkbox>
                      Отправка пользователю в WhatsApp уведомлений о смене
                      статусов всех записей
                    </Checkbox>
                  </Form.Item>
                )}
              </div>
            </Flex>
          </div>

          {error && (
            <CustomAlert
              errorType={ERROR}
              serverError={error}
              setServerError={setError}
            />
          )}

          <Button
            type="primary"
            htmlType="submit"
            className="save-button"
            size="large"
            loading={isLoading}
            data-testid="save"
          >
            Сохранить
          </Button>
        </Space>
      </Form>
    </div>
  );
};
